var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portal-item__container",on:{"click":_vm.handleRedirection}},[_c('div',{staticClass:"portal-item__title"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{staticClass:"portal-item__image"},[_c('img',{attrs:{"src":_vm.icon,"alt":"app-icon-selected"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }